import { useCallback, useEffect, useRef, useState } from "react";
import useBaseURL from "config/useBaseUrl.js";

/**
 * Polje „Inery Node URL" na prijavi i registraciji: početna vrednost sa
 * servera, a dalje šta korisnik upiše.
 *
 * ZAŠTO POSTOJI: ta vrednost je bila konstanta u kodu, prevedena u klijentski
 * paket. Ista na svakoj mašini — dakle tačna samo na onoj za koju je pisana.
 * Na TAS-u je 24.09.2026. nudila adresu na kojoj čvora nema; svaka provera je
 * vraćala 400 i nijedan nalog se nije mogao napraviti. Server tu adresu zna,
 * stoji mu u `.env`-u kao `BLOCKCHAIN_URL`, pa se odatle i uzima.
 *
 * Polje ostaje izmenjivo namerno: čvor ne mora biti na istoj mašini kao GUI —
 * tipično kad GUI radi u kontejneru, a čvor van njega.
 *
 * NEMA ugrađene rezervne vrednosti. Ako server ne odgovori ili `BLOCKCHAIN_URL`
 * nije podešen, polje ostaje prazno i korisnik ga popuni. Svaka pogođena
 * vrednost — a pogotovo port — bila bi ista ona greška koja je ovo i
 * izazvala: broj iz koda koji se predstavlja kao podešavanje.
 *
 * Odgovor sa servera NE gazi ono što je korisnik već otkucao. Stigne posle
 * iscrtavanja, pa bi mu inače u pola reči pojeo unos.
 *
 * @returns {[string, (vrednost: string) => void]}
 */
export const useServerUrlField = () => {
  const baseURL = useBaseURL();
  const [serverURL, postavi] = useState("");
  const diraoKorisnik = useRef(false);

  useEffect(() => {
    let otkazano = false;

    (async () => {
      try {
        const odgovor = await fetch(`${baseURL}/api/utils/node_url`);
        if (!odgovor.ok) return;

        const { node_url: adresa } = await odgovor.json();
        if (adresa && !otkazano && !diraoKorisnik.current) postavi(adresa);
      } catch {
        // Namerno progutano: polje ostaje prazno i korisnik ga popuni. Ako
        // backend ne odgovara, ionako ništa drugo u GUI-ju ne radi.
      }
    })();

    return () => {
      otkazano = true;
    };
  }, [baseURL]);

  const promeni = useCallback((vrednost) => {
    diraoKorisnik.current = true;
    postavi(vrednost);
  }, []);

  return [serverURL, promeni];
};

export default useServerUrlField;
